import { render } from "./FacturadorView.vue?vue&type=template&id=67e0e507&scoped=true"
import script from "./FacturadorView.vue?vue&type=script&lang=js"
export * from "./FacturadorView.vue?vue&type=script&lang=js"

import "./FacturadorView.vue?vue&type=style&index=0&id=67e0e507&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e0e507"]])

export default __exports__